import type { ReactNode } from 'react';
import { FilterAltOffOutlined } from '@mui/icons-material';
import { EmptyState, FilterChip, Pagination, type CustomPanelControls } from '@practium/ui';
import { MIXTURE_CUSTOM_DAY_FILTER } from '../../constants/mixtures.constants';
import type { useMixtureListFilter } from '../../hooks/useMixtureListFilter';
import { MixtureDayRangePanel } from './MixtureDayRangePanel';
import styles from './MixturesPanel.module.css';

interface MixtureCardListProps {
	list: ReturnType<typeof useMixtureListFilter>;
	children: ReactNode;
}

export const MixtureCardList = ({ list, children }: MixtureCardListProps) => {
	const renderDayRangePanel = ({ close, activate, deactivate }: CustomPanelControls) => (
		<MixtureDayRangePanel
			month={list.month}
			eventDays={list.eventDays}
			dateFrom={list.dateFrom}
			dateTo={list.dateTo}
			onApply={(from, to) => {
				list.setDateRange(from, to);
				activate();
			}}
			onClear={() => {
				list.setDateRange('', '');
				deactivate();
			}}
			onClose={close}
		/>
	);

	return (
		<div className={styles.cardList}>
			<div className={styles.listToolbar}>
				<FilterChip
					values={list.filterValues}
					onChange={list.setFilterValues}
					groups={list.filterGroups}
					placeholder="Filtros"
					customPanels={{ [MIXTURE_CUSTOM_DAY_FILTER]: renderDayRangePanel }}
				/>
			</div>
			{list.isFilteredEmpty ? (
				<EmptyState
					icon={<FilterAltOffOutlined />}
					title="Nenhuma mistura encontrada"
					description="Ajuste os filtros para ver outras misturas do mês."
				/>
			) : (
				<div className={styles.cards}>{children}</div>
			)}
			<Pagination page={list.page} totalPages={list.totalPages} onPageChange={list.setPage} />
		</div>
	);
};
